import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ServicePointsAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  createSuccess() {
    const message = {
      body: 'SERVICE_POINT_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message, null, null)
  }

  createError() {
    const message = {
      body: 'SERVICE_POINT_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateSuccess() {
    const message = {
      body: 'SERVICE_POINT_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'SERVICE_POINT_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteSuccess(servicePoint) {
    const message = {
      body: 'SERVICE_POINT_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message, {name: servicePoint.name})
  }

  deleteError() {
    const message = {
      body: 'SERVICE_POINT_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  exportSuccess() {
    const message = {
      body: 'SERVICE_POINTS_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'SERVICE_POINTS_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  importSuccess() {
    const message = {
      body: 'SERVICE_POINTS_IMPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  importError() {
    const message = {
      body: 'SERVICE_POINTS_IMPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  validationError() {
    const message = {
      body: 'SERVICE_POINTS_VALIDATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }
}

angular
  .module('bringoz.admin.service-points')
  .service('servicePointsAlerts', ServicePointsAlerts);
